import {createElement, PropTypes} from 'rlink-react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import DocumentOpenGraphProperty from 'rlink-react-document/DocumentOpenGraphProperty.jsx';
import DocumentFacebookProperty from 'rlink-react-document/DocumentFacebookProperty.jsx';
import {FB_APPID} from 'terms';
import getCurrentRouteState from 'rlink-router/getCurrentRouteState';
import {injectIntl, defineMessages} from 'react-intl';
import {default as RoutingComponent, NavLink} from 'rlink-router/component';
import SidebarNav from './sidebar-nav';
import NewsletterCTA from './newsletter-cta';
import Footer from './footer';
import css from 'static/style/dow.less';
import RegionPickerTheme from 'static/style/components/RegionPicker.less';
import contentLoader from 'helpers/content-loader';
import RegionPicker from 'rlink-regions/components/cookie/RegionPicker';
import connectToPathForContent from 'rlink-repos/connectToPathForContent';
import getPreferredLanguages from 'rlink-regions/getPreferredLanguages';
import getUserSelectedCountry from 'rlink-regions/getUserSelectedCountry';
import getRegionForCountry from 'rlink-regions/getRegionForCountry';
import getCountryFromPreferredLanguages from 'rlink-regions/getCountryFromPreferredLanguages';
import {getCookies} from 'rlink-utils/Cookies';

import openModal from 'rlink-router/actions/openModal';
import popModal from 'rlink-router/actions/popModal';

import {SKU_GROUPS, RATINGS_BOARDS, REGION_RESTRICTIONS} from 'region-config';

import {DOW} from '../terms';

//Modal Style Override
import 'theme/rlink-modal/Modal.less';

const INTL_MESSAGES = defineMessages({
  AGEGATE_PROMPT: {
    id: 'ui.label.title.AGEGATE_PROMPT',
    defaultMessage: 'Please verify your age',
    description: 'Prompt for the age gate, which shows up the first time people visit the site.',
  },
  AGEGATE_SUBMIT_LABEL: {
    id: 'ui.label.button.AGEGATE_SUBMIT',
    defaultMessage: 'Enter',
    description: 'Text for the button used to submit your age and continue on to the site.',
  },
});

const LOADING_CLASS = 'loading';

// To keep critical.js small we just use the string directly
// instead of importing a constant. Don't forget that this is also
// used there.
const HIDE_CONTENTS_CLASS = 'hide-contents';

class Main extends RoutingComponent {
  constructor (...args) {
    super(...args);

    this.state = {
      navOpen: false,
    };
  }

  componentWillMount () {
    if (typeof document !== 'undefined') {
      if (document.body.classList.contains(HIDE_CONTENTS_CLASS)) {
        const regionPicker = (
          <RegionPicker
            togglable
            skuGroups={SKU_GROUPS}
            ratingsBoards={RATINGS_BOARDS}
            useFlags
            regionRestrictions={REGION_RESTRICTIONS}
            type={RegionPicker.renderTypes.COUNTRY_RADIO}
            showPlaceholder
            sortBy={[RegionPicker.sortTypes.ALPHABETICAL]}
            theme={RegionPickerTheme} />
        );

        this.props.dispatch(openModal({
          view: 'agegate',
          buildContext: this.context.buildContext,
          fullscreen: true,
          params: {
            regionPicker,
            logo: contentLoader('DOW_LOGO_BG.png'),
            prompt: this.props.intl.formatMessage(INTL_MESSAGES.AGEGATE_PROMPT),
            submitLabel: this.props.intl.formatMessage(INTL_MESSAGES.AGEGATE_SUBMIT_LABEL),
            onDisable: () => {
              document.body.classList.remove(HIDE_CONTENTS_CLASS);

              // We need to delay this with 10 millisecond so it isn't
              // applied immediately at the same time as the
              // HIDE_CONTENT_CLASS removal, which makes opacity and
              // display apply at the same time, and the opacity
              // transition won't happen. The requestAnimationFrame is
              // too fast as well.
              setTimeout(() => {
                document.body.classList.remove(LOADING_CLASS);
              }, 10);

              this.props.dispatch(popModal());

              this.setState({renderRegionPicker: true});
            },
          },
        }));
      } else {
        this.setState({renderRegionPicker: true});
      }

      this.loadCivicCookieTool();
    }
  }

  loadCivicCookieTool() {
    var googleId = 'UA-51251305-1';
      var config = {
        apiKey: '06b4a0da4fb90ed8335a0de43cbcfff68730faee',
        product: 'PRO_MULTISITE',
        initialState: 'notify',
        branding: {
          backgroundColor: '#1e2125',
          acceptBackground: '#bea87e',
          toggleBackground: '#080808',
          toggleColor: '#b32b15',
          removeAbout: true
        },
        text: {
          notifyDescription: 'Cookies help us deliver our services and provide personalised experiences. By using this website, you agree to our use of cookies. You can find out how to manage your preferences in relation to our use of cookies at <a target="_blank" href="https://content.relic.com/legal/cookiepolicy.html" class="GDPRMessageLink"> Cookie Policy </a>'
        },
        necessaryCookies: ['country', 'rlink-agegate-birthday', 'sidebarVisible', 'sidebarVisibleFallback', '_simpleauth_sess', 'csrf_cookie', '__stripe_mid', '__stripe_sid'],
        optionalCookies: [
          {
            name: 'analytics',
            label: 'Analytical Cookies',
            description: 'Analytical cookies help us to improve our website by collecting and reporting information on its usage.',
            recommendedState: true,
            cookies: ['_ga', '_gid', '_gat', 'IDE', 'NID', 'GPS', 'PREF', 'VISITOR_INFO1_LIVE', 'YSC'],
            thirdPartyCookies: [
              {
                'name': 'Google',
                'optOutLink': 'https://policies.google.com/technologies/cookies'
              },
              {
                'name': 'Google Ads',
                'optOutLink': 'https://adssettings.google.com/'
              }
            ],
            onAccept : function(){
              (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
              (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
              m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
              })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

              ga('create', googleId, 'auto');
              ga('send', 'pageview');

              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-WFMGJJ');
            },
            onRevoke: function(){
              window['ga-disable-' + googleId] = true;
            }
          },{
            name: 'social',
            label: 'Social Sharing Cookies',
            description: 'We may use social sharing plugins to allow you to share certain pages of our website on your social media pages. These plugins place cookies so that you can correctly view how many times a page has been shared.',
            cookies: ['_fbp', 'fr', '_js_datr', 'sb', 'wd'],
            recommendedState: true,
            thirdPartyCookies: [
              {
                'name': 'Facebook',
                'optOutLink': 'https://en-gb.facebook.com/policies/cookies/'
              },
            ],
            onAccept : function() {
              window.fbAsyncInit = function() {
                FB.init({
                  appId      : 1290376697659159,
                  xfbml      : true,
                  version    : 'v2.6'
                });
              };

              (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {return;}
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
              }(document, 'script', 'facebook-jssdk'));
            },
            onRevoke: function() {}
          }
      ],
      position: 'LEFT',
      theme: 'DARK'
    };

    CookieControl.load( config );
  }

  componentDidMount () {
    if (typeof document !== 'undefined'
        && !document.body.classList.contains(HIDE_CONTENTS_CLASS)) {
      document.body.classList.remove(LOADING_CLASS);
    }
  }

  render () {
    if (this.props.bare) {
      return this.viewContent();
    }

    let preferredLanguages = getPreferredLanguages();
    let userCountry = getUserSelectedCountry();

    if (userCountry === null) {
      userCountry = getCountryFromPreferredLanguages(preferredLanguages);
    }

    let region = (this.state && this.state.params && this.state.params.region)
      ? this.state.params.region
      : getRegionForCountry(userCountry, SKU_GROUPS, REGION_RESTRICTIONS);

    return (
      <div className={`
              ${css.layout}
              ${css[`view_${this.props.currentView}`]}
              ${css[(this.state.navOpen) ? 'navigation-sidebar-active' : 'navigation-sidebar-inactive']}
        `}>
        <DocumentFacebookProperty property="app_id" value={FB_APPID} />
        <DocumentOpenGraphProperty property="site_name" value={DOW} />
        <DocumentOpenGraphProperty property="locale" value="en_US" />
        <SidebarNav
          getCookies={() => getCookies()}
          view={this.props.currentView}
          setNavState={value => this.setState({navOpen: value})}
          navOpen={this.state.navOpen} />
        <div className={css['content-container']}>
          <div>
            <header>
              <NavLink className={`${css['logo-link']} ${(this.props.currentView !== 'faction') ? '' : css.hidden}`} href={{view: 'home'}}>
                <img src={contentLoader('dow3_logo.png')} alt={this.props.intl.formatMessage(DOW.props)} className={css.logo} />
              </NavLink>
              {this.state && this.state.renderRegionPicker
                && <RegionPicker
                     togglable
                     skuGroups={SKU_GROUPS}
                     ratingsBoards={RATINGS_BOARDS}
                     useFlags
                     regionRestrictions={REGION_RESTRICTIONS}
                     type={RegionPicker.renderTypes.COUNTRY_RADIO}
                     theme={RegionPickerTheme}
                     showPlaceholder
                     sortBy={[RegionPicker.sortTypes.ALPHABETICAL]} />}
            </header>

            {this.viewContainer()}

            <NewsletterCTA
              css={css}
              links={{
                sso_signup: 'https://sso.relic.com/signup?title=dow3&newsletterOnly=1',
              }} />
            <Footer
              globalSettings={
                (this.props.globalSettings)
                  ? this.props.globalSettings
                  : {}
              }
              region={region.toString()}
              esrbDetails={
                (this.props.currentView === 'buy')
                  ? { image: contentLoader('esrb-store-footer.png'), reasons: ['Blood and Gore', 'Violence'] }
                  : {}
              }
              css={css} />
          </div>
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  view: PropTypes.string,
};

Main.defaultProps = {
  theme: css,
  view: '',
};

Main.contextTypes = {
  buildContext: PropTypes.any,
};

export default compose(
  injectIntl,
  connect(({routing}) => {
    let {view} = getCurrentRouteState(routing);
    return {currentView: view};
  }),
  connectToPathForContent
)(Main);



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/main.jsx